import { render } from "./LocationEdit.vue?vue&type=template&id=52992159"
import script from "./LocationEdit.vue?vue&type=script&lang=js"
export * from "./LocationEdit.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__